import { useContext } from 'react'

import { FollowUpReabAlertContext } from '@provider/Alerts/FollowUpReabProvider'

import { IFollowUpReabAlertContext } from '@base/@types/providers/Alert/FollowUpReabProvider'

export default function useFollowUpReabAlert(): IFollowUpReabAlertContext {
  const context = useContext(FollowUpReabAlertContext)

  return context
}
